import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatoPaginadoModel } from 'src/app/shared/models/dato-paginado.model';
// tslint:disable-next-line:max-line-length
import { EstablecimientoComercioService } from '../../containers/bandeja-principal/prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { BasicasLoVService } from 'src/app/shared/services/basicas-lov.service';
import { DepartamentoEntry } from 'src/app/shared/entrys/departamento.entry';
import { MunicipioEntry } from 'src/app/shared/entrys/municipio.entry';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
	selector: 'app-modal-establecimiento',
	templateUrl: './modal-establecimiento.component.html',
	styleUrls: ['./modal-establecimiento.component.scss'],
})
export class ModalEstablecimientoComponent implements OnInit {
	@Input()
	datoPaginadoModel: DatoPaginadoModel;
	headers: Array<string>;
	modalGenerico: ModalGenericoModel;
	selectData: EstablecimientoEntry;
	camarasLista: Array<CamaraComercioEntry>;
	departamentos: Array<DepartamentoEntry>;
	municipios: Array<MunicipioEntry>;
	filtro: FormGroup;
	establecimientos: Array<EstablecimientoEntry>;
	paginaActual: number;
	public isCollapsed = true;
	constructor(private activeModal: NgbActiveModal, private dataSharedService: DataSharedService, private ref: ChangeDetectorRef,
		private establecimientoComercioService: EstablecimientoComercioService, private authService: AuthService,
		private basicasLoVService: BasicasLoVService, public fb: FormBuilder) {
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.createForm();
		this.consultarListas();
		this.modalGenerico = {
			titulo: 'Seleccionar establecimiento'
		};
		this.headers = ['', 'Nombre del establecimiento', 'Dirección', 'Departamento', 'Ciudad', 'Cámara de comercio', 'Número de matrícula'];
	}

	createForm() {
		this.filtro = this.fb.group({
			nombre_establecimiento: [''],
			departamento_id: [''],
			municipio_id: [''],
			codigo_camara: [''],
			matricula: ['']
		});
	}

	limpiar() {
		this.filtro.reset();
		this.consultaTabla();
		this.paginaActual = 1;
	}

	selectRow(row: EstablecimientoEntry) {
		this.selectData = row;
	}

	confirm(): void {
		if (this.activeModal && this.selectData) {

			localStorage.setItem("keyCamaraID", this.selectData.codigo_camara);
			localStorage.setItem("keyMatricula", this.selectData.matricula);
			this.activeModal.close(this.selectData);
		}
	}

	dismiss(): void {
		if (this.activeModal) {
			this.activeModal.dismiss();
		}
	}
	onPaginado(pagina: number) {
		// tslint:disable-next-line:max-line-length
		this.establecimientoComercioService.getEstablecimientoPorUsuario({ usuario: this.authService.getUserNameToken() }, pagina).subscribe(result => {
			if (result.result) {
				this.datoPaginadoModel = result.data as DatoPaginadoModel;
				this.paginaActual = pagina;
			}
		});
	}
	consultarListas() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
			}
		});
		this.basicasLoVService.getDepartamentos(null).subscribe(resultado => {
			if (resultado.result) {
				this.departamentos = resultado.data as Array<DepartamentoEntry>;
			}
		});
	}

	consultaTabla() {
		this.establecimientoComercioService.getEstablecimientoPorUsuario(this.filtro.value, 1).subscribe(resultado => {
			if (resultado.result) {
				this.datoPaginadoModel = resultado.data as DatoPaginadoModel;
				this.paginaActual = 1;
			}
		});
	}

	onMunicipio() {
		this.basicasLoVService.getMunicipiosxDepartamento(this.filtro.value.departamento_id).subscribe(resultado => {
			if (resultado.result) {
				this.municipios = resultado.data as Array<MunicipioEntry>;
			}
		});
	}
}
